export default function Footer() {
  return (
    <footer className="bg-[#2C1810] text-white">
      <div className="px-6 lg:px-16 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <h4 className="text-2xl font-black tracking-tight mb-1">鮮肉本舖</h4>
            <p className="text-white/40 text-xs tracking-widest mb-5">FRESH MEAT MARKET</p>
            <p className="text-white/60 text-sm leading-relaxed max-w-sm mb-6">
              嚴選台灣在地及進口優質肉品，每日新鮮到貨，嚴格把關品質，讓您在家也能享受餐廳級的美味。
            </p>

          </div>
          <div>
            <h5 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-5">商品分類</h5>
            <ul className="space-y-3">
              {['全部商品','豬肉','牛肉','雞肉','羊肉'].map((item) => (
                <li key={item}><a href="#products" className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer">{item}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h5 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-5">客服資訊</h5>
            <ul className="space-y-3">
              {['常見問題','配送說明','退換貨政策','聯絡我們'].map((item) => (
                <li key={item}><a href="#" className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer">{item}</a></li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 px-6 lg:px-16 py-5 flex flex-col sm:flex-row items-center justify-between space-y-2 sm:space-y-0">
        <p className="text-white/30 text-xs">© 2026 鮮肉本舖 All Rights Reserved</p>
        <p className="text-white/30 text-xs">元益有限公司 · 統編 60573934</p>
      </div>
    </footer>
  );
}
